import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ProductDetailsPopUp = ({ onClose, open, products, title }) => {
    const handleClose = () => {
        onClose();
    };
    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="lg"
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    {title}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <DynamicTable
                        data={products}
                        tableHead={[
                            {
                                name: "index",
                                title: "Sr.No",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                            },
                            {
                                name: "name",
                                title: "Product Name",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                            },
                            {
                                name: "categoryName",
                                title: "Category Name",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                            },
                        ]}
                        showPegination={false}
                        isActionColActive={false}
                    />
                    <br />
                </DialogContent>
            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductDetailsPopUp);
